import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

export const ModalContent = styled.div`
  background: #fff;
  justify-content: center;
  border-radius: 12px;
  width: 512px;
  text-align: center;
  height: 250px;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    padding: 0 1.5rem;
    width: 70%;
  }

  img {
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
`;

export const ModalButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const CancelButton = styled.button`
  width: 184px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid #afafaf;
  color: #afafaf;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    width: 100%;
  }
`;

export const ModalDeleteButton = styled.button`
  background-color: #00a603;
  color: #ffffff;
  border-radius: 10px;
  width: 184px;
  height: 44px;
  border: none;
  @media screen and (min-width: 0px) and (max-width: 767px) {
    width: 100%;
  }
`;
